// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuex from 'vuex'
import stores from './stores'
import App from './App'
import router from './router'
import * as filters from './filters'
import Axios from 'axios'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import axios from  'axios'


Vue.config.productionTip = false;
Vue.prototype.$axios = axios;

Vue.use(ElementUI);
Vue.config.productionTip = false

Vue.prototype.$axios = Axios
//注册filter
Object.keys(filters).forEach(k => Vue.filter(k, filters[k]))

axios.defaults.retry = 4;
axios.defaults.retryDelay = 1000;

Vue.use(Vuex)
const store = new Vuex.Store(stores)

toastr.options.closeButton = true
toastr.options.closeMethod = 'fadeOut'
toastr.options.closeDuration = 300
toastr.options.closeEasing = 'swing'
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
  data: {
    eventHub: new Vue() //global event bus
  }
})



// WEBPACK FOOTER //
// ./src/main.js